import NeighborhoodPage from "@/components/NeighborhoodPage";

const Laranjeiras = () => (
  <NeighborhoodPage
    name="Laranjeiras"
    slug="laranjeiras"
    description="Charme, arborização e arquitetura clássica no coração da Zona Sul. Laranjeiras reúne prédios históricos, casarões e uma vida de bairro rara no Rio de Janeiro."
  />
);

export default Laranjeiras;
